/**
 * Jesus calms the storm coloring pages — authored via the `/pack` toile process (plan
 * `thinking/plans/2026_08_31_toile_pack_wiring.md` Track B), wave `toile_bible_stories`. Narcis file-split
 * shape (Track A): one module per pack, `registry.ts` assembles them into `livePacks`.
 */
import {tagline, chips, type ToilePack} from './data'

export const jesusCalmsTheStormColoringPagesPack: ToilePack = {
    slug: 'jesus-calms-the-storm-coloring-pages',
    category: 'faith',
    name: 'Jesus calms the storm coloring pages',
    tagline: tagline('pieces', 'themes', 'styles'),
    chips: chips('themes', 'styles'),
    ratio: {w: 832, h: 1216},
    readings: [
        {key: 'asleep', label: 'Asleep', subject: 'Jesus asleep on a cushion in the stern of a fishing boat as the waves begin to rise around it'},
        {key: 'waking', label: 'Waking him', subject: 'the frightened disciples waking Jesus as water splashes over the sides of the boat in the wind'},
        {key: 'calm', label: 'The calm', subject: 'Jesus standing in the boat with his hand raised over a sea now smooth and still, the disciples amazed'},
    ],
    styles: [
        {key: 'bold', label: 'Bold and simple', style: 'bold thick-outline coloring book style, one heavy uniform black line, big simple open shapes for young children', palette: 'black ink only', framing: 'The drawing centered with a wide white margin on all sides'},
        {key: 'classic', label: 'Classic', style: 'classic coloring book line art, medium uniform black line, moderate detail and open shapes for ages six to nine', palette: 'black ink only', framing: 'The full page used, the drawing centered with a white margin'},
        {key: 'detailed', label: 'Fine detail', style: 'fine-line detailed coloring page, thin uniform black line, patterned robes, leaves and waves for older children', palette: 'black ink only', framing: 'The scene held inside a plain thin rectangular border with a white margin outside it'},
    ],
    directions: ['jesus walks', 'rainbow', 'sunset sea'],
    directionHint: 'try: jesus walks',
    seo: {
        title: 'Jesus Calms the Storm Coloring Pages: Mark 4',
        metaDescription: 'Nine coloring pages of Jesus calming the storm from Mark 4: asleep in the boat, the disciples waking him and the still sea, in three styles.',
        h1: 'Jesus calms the storm coloring pages: asleep in the boat, waking him, the calm',
        tagline: 'Nine pages of Mark 4 in three scenes, each in three line weights.',
        intro: 'Printable Jesus calms the storm coloring pages for Sunday school and Christian homeschool, from Mark 4. Three scenes: Jesus asleep in the stern as the waves rise, the frightened disciples waking him as water splashes in, and Jesus standing with his hand raised over a sea now still. Bold, classic and fine-detail lines. Type a different scene, and the same styles carry it.',
        useCases: [
            'a Sunday school lesson on Mark 4',
            "a children's church craft table",
            'a Christian homeschool Gospel unit',
            'a bulletin board on trusting Jesus',
        ],
        faq: [
            {q: 'Which part of Mark 4 do these show?', a: 'Jesus asleep in the boat, the disciples waking him, and the sea made still.'},
            {q: 'Can I ask for Jesus walking on the water?', a: 'Yes. Type the scene you want. The request shapes the page, but a result is not promised to match it exactly.'},
            {q: 'Which style suits a young child?', a: 'Bold and simple, with one heavy line and big open shapes.'},
            {q: 'Are the pages in color?', a: 'No. Each page is black line on white, with open shapes to color in.'},
        ],
    },
}
